import React, { useState } from "react";
import List from "../../../../styledComponents/Table/List";
import menuIcon from "../../../../../assets/images/DeathModuleNew/Menu.png";
import plaidIcon from "../../../../../assets/images/budget/plaidlogo.png";
import { Modal, Table } from "antd";
import swal from "sweetalert";
import moment from "moment";

export const AccountTransaction = (props) => {
  const [dropdown, setDropdown] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedObject, setSelectedObject] = useState(null);

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  // Sort the selectedObject array based on the current sort configuration
  const sortedData =
    selectedObject &&
    [...selectedObject].sort((a, b) => {
      if (sortConfig.key === "date") {
        return sortConfig.direction === "asc"
          ? new Date(a.date) - new Date(b.date)
          : new Date(b.date) - new Date(a.date);
      } else if (sortConfig.key === "amount") {
        return sortConfig.direction === "asc"
          ? a.amount - b.amount
          : b.amount - a.amount;
      }
      return 0;
    });

  // Function to handle sorting logic
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  // Function to render sorting icons
  // const renderSortIcon = (key) => {
  //   if (sortConfig.key !== key) return null;
  //   return sortConfig.direction === "asc" ? "▲" : "▼";
  // };

  const totalAmount =
    props.transactions &&
    props.transactions &&
    props.transactions.reduce((total, item) => {
      return total + item.amount;
    }, 0);
  function getFrequency(days) {
    if (days >= 364 && days <= 366) {
      return "Yearly";
    } else if (days >= 56 && days <= 62) {
      return "Bimonthly";
    } else if (days >= 28 && days <= 32) {
      return "Monthly";
    } else if (days >= 13 && days <= 17) {
      return "Biweekly";
    } else if (days >= 5 && days <= 9) {
      return "Weekly";
    } else {
      return "Irregular";
    }
  }
  function calculateDueStatus(record) {
    const currentDate = new Date();
    let dueDate = new Date(record.dueDate);

    let nextDueDate = new Date(dueDate); // Start from the original due date

    switch (record.frequency) {
      case "Monthly":
        // Set to the same day in the current month if today hasn’t passed the due day, else set it to the next month
        nextDueDate.setFullYear(currentDate.getFullYear());
        nextDueDate.setMonth(currentDate.getMonth());
        nextDueDate.setDate(dueDate.getDate());

        if (currentDate > nextDueDate) {
          nextDueDate.setMonth(currentDate.getMonth() + 1);
        }
        break;

      case "Weekly":
        // Move to the next 7-day cycle until it’s in the future
        while (nextDueDate <= currentDate) {
          nextDueDate.setDate(nextDueDate.getDate() + 7);
        }
        break;

      case "Yearly":
        // Set to the same day of this year or next year if today has passed this year’s due date
        nextDueDate.setFullYear(currentDate.getFullYear());
        nextDueDate.setMonth(dueDate.getMonth());
        nextDueDate.setDate(dueDate.getDate());

        if (currentDate >= nextDueDate) {
          nextDueDate.setFullYear(currentDate.getFullYear() + 1);
        }
        break;

      default:
        return "Expired";
    }

    if (dueDate.toDateString() === currentDate.toDateString()) {
      return "Today";
    } else if (dueDate < currentDate) {
      const timeDifference = nextDueDate.getTime() - currentDate.getTime(); // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
      return `In ${daysDifference} days`;
      // return `Next: ${nextDueDate.toDateString()}`;
      // return "Expired";
    } else {
      const timeDifference = dueDate.getTime() - currentDate.getTime(); // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
      return `In ${daysDifference} days`;
      // return `${moment(record).format("MM-DD-YYYY")} (${daysDifference} days)`;
    }
  }
  const cols = [
    {
      title: "Item",
      dataIndex: "itemName",
      sorter: (a, b) => (a.itemName || "").localeCompare(b.itemName || ""),
      render: (fileName, record) => {
        return record.itemName ? (
          <React.Fragment>
            <div
              style={{ display: "flex", gap: "6px", cursor: "pointer" }}
              onClick={() => {
                // if (record.frequency && record.frequency !== "Irregular") {
                getSelectedRecords(record.itemName);
                // }
              }}
            >
              <img
                style={{ borderRadius: "50%" }}
                height={34}
                width={34}
                src={record.itemLogo ? record.itemLogo : plaidIcon}
              ></img>
              <div>
                <div>{record.itemName}</div>
                <div style={{ color: "#2a3da3", fontWeight: "bold" }}>
                  {record.frequency && record.frequency}
                </div>
                {record.frequency && record.frequency !== "Irregular" && (
                  <div style={{ color: "#79797D", fontWeight: "lighter" }}>
                    {record.frequency === "Monthly"
                      ? "1 Subscription"
                      : record.occurance && record.occurance + "Subscriptions"}
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Bank",
      dataIndex: "bankName",
      sorter: (a, b) => (a.bankName || "").localeCompare(b.bankName || ""),
      render: (fileName, record) => {
        return record.bankName ? (
          <div>
            <div>{record.bankName}</div>
            {record.accountType && (
              <span style={{ color: "black" }}>{record.accountType}</span>
            )}
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Account",
      dataIndex: "bankName",
      sorter: (a, b) =>
        (a.accountNumber || "").localeCompare(b.accountNumber || ""),
      render: (fileName, record) => {
        return record.accountNumber ? (
          <div>
            <div>{"****" + record.accountNumber}</div>
          </div>
        ) : (
          "N/A"
        );
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      sorter: (a, b) => {
        const amountA = parseFloat(a.amount);
        const amountB = parseFloat(b.amount);
        // Toggle sorting order directly
        if (amountA < amountB) {
          return -1; // Sort in ascending order
        } else if (amountA > amountB) {
          return 1; // Sort in descending order
        } else {
          return 0; // Leave items unchanged if they are equal
        }
      },
      render: (record) => (
        <div
          style={{
            width: "100%",
            fontWeight: "bold",
            // color: record < 0 ? "#00A27B" : "",
            color: record < 0 ? "black" : "#00A27B",
          }}
        >
          {record
            ? !isNaN(record)
              ? `${record && record < 0
                    ?  "$" + record.toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    :  "$" + record
                        .toFixed(2)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }`
              : "N/A"
            : "N/A"}
        </div>
      ),
    },
    {
      title: "Due",
      dataIndex: "date",
      sorter: (a, b) => (a.date || "").localeCompare(b.date || ""),
      render: (fileName, record) => {
        if (record.date) {
          return calculateDueStatus(record);
        } else {
          return "N/A";
        }
      },
    },
    // {
    //   title: "Category",
    //   dataIndex: "categoryFromPlaid",
    //   sorter: (a, b) =>
    //     (a.categoryFromPlaid || "").localeCompare(b.categoryFromPlaid || ""),
    //   render: (record) => (record ? record : "N/A"),
    // },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex" }} key={index}>
              {" "}
              <img
                style={{ cursor: "pointer", marginRight: "1rem" }}
                src={menuIcon}
                alt="menuIcon"
                height={15}
                width={4}
                onClick={() => {
                  console.log("recode", record);
                  setSelectedItemId(record.id);
                  setDropdown(!dropdown);
                }}
              ></img>{" "}
              {dropdown && selectedItemId === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>
                  <div className="dropdown" style={{ zIndex: "9999" }}>
                    <ul className="dropdownul">
                      {/*<li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          //   props.handleOpen();
                          //   handleFormDataUpdate(record);
                        }}
                      >
                        Update
                      </li>*/}

                      {/*<li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          props.deleteTransaction(record.id);
                        }}
                      >
                        Delete
                      </li> */}
                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          if (props && props.tabName === "Hidden") {
                            // swal("Error!", "Already Hidden.", "error");
                            props.restoreRecurringTransaction(record.id);
                          } else {
                            props.hideRecurringTransaction(record.id);
                          }
                        }}
                      >
                        {props && props.tabName === "Hidden"
                          ? "Restore"
                          : "Hide"}
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
            </div>
          </React.Fragment>
        );
      },
    },
  ];
  const getSelectedRecords = async (name) => {
    setDetailsModal(true);
    const transaction = props.clientTransactions && props.clientTransactions;
    const recurringTransactions =
      transaction &&
      transaction.filter((item) => {
        return item.itemName === name;
      });
    setSelectedObject(recurringTransactions);
  };
  const handleCancel = () => {
    setDetailsModal(false);
    setSelectedObject(null);
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return null; // No icon if the column is not sorted

    // Return both icons, with the appropriate one being active
    return (
      <>
        {sortConfig.direction === "asc" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "white", fontSize: "8px" }}>▲</span>{" "}
            {/* Upward arrow */}
            <span style={{ color: "gray", fontSize: "8px" }}>▼</span>{" "}
            {/* Downward arrow (inactive) */}
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ color: "gray", fontSize: "8px" }}>▲</span>{" "}
            {/* Upward arrow (inactive) */}
            <span style={{ color: "white", fontSize: "8px" }}>▼</span>{" "}
            {/* Downward arrow */}
          </div>
        )}
      </>
    );
  };
  return (
    <div>
      <div className="subheading">
        {props.tabName}{" "}
        {props.tabName !== "All Accounts" && (
          <span className="subheading_amount">
            (${" "}
            {totalAmount
              ? `${totalAmount
                  .toFixed(2)
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
              : "0"}
            )
          </span>
        )}
      </div>
      <div className="tableContainer">
        <Table
          rowKey="id"
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: props.selectedRowKeys,
            onChange: (selectedRowKeys, selectedRows) => {
              console.log("selectedRowKeys:", selectedRowKeys);
              console.log("selectedRows:", selectedRows);
              props.selectedRowsDataKeys(selectedRowKeys);
            },
          }}
          pagination={{
            showSizeChanger: true, // Show the page size changer
            pageSizeOptions: ["10", "20", "50", "100"], // Options for page size
            defaultPageSize: 10, // Default page size
          }}
          columns={cols}
          dataSource={props.transactions && props.transactions}
        />

        {/*<List cols={cols} rows={props.transactions && props.transactions} /> */}
      </div>
      <Modal
        visible={detailsModal}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <h3 className="modaltitle">Transaction Details</h3>

        <div>
          <div className="" style={{ maxHeight: "18rem", overflow: "auto" }}>
            {sortedData && sortedData.length > 0 ? (
              <table id="clients">
                <thead>
                  <tr>
                    <th
                      onClick={() => handleSort("date")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Date {renderSortIcon("date")}
                    </th>
                    <th>Name</th>
                    <th>Category</th>
                    <th
                      onClick={() => handleSort("amount")}
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      Amount {renderSortIcon("amount")}
                    </th>
                  </tr>
                </thead>
                <tbody style={{}}>
                  {sortedData &&
                    sortedData.map((data, index) => (
                      <tr key={index}>
                        <td>
                          {data.date
                            ? moment(data.date).format("MM-DD-YYYY")
                            : "N/A"}
                        </td>
                        <td>{data.itemName ? data.itemName : "N/A"}</td>
                        <td>
                          {data.categoryFromPlaid
                            ? data.categoryFromPlaid
                            : "N/A"}
                        </td>
                        <td>
                          {" "}
                          ${" "}
                          {data.amount
                            ? `${data.amount
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
                            : "0"}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            ) : (
              <h3 className="inputTitle">No Transaction to Show</h3>
            )}
          </div>
        </div>

        <div className="buttonsMain" style={{ justifyContent: "center" }}>
          <button
            className="savebutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Close
          </button>
        </div>
      </Modal>
    </div>
  );
};
